import { render, staticRenderFns } from "./ProjectMaterialEdit.vue?vue&type=template&id=cb236642"
import script from "./ProjectMaterialEdit.vue?vue&type=script&lang=js"
export * from "./ProjectMaterialEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports